module.exports = __webpack_public_path__ + "1dcba3cb4b707cb4949feae3c974fac5.pdf";